import { LANGUAGE_EN } from '@op/_config/config';
import BubbleCommon, {
  aiTaskDownloadDisabledTips,
  aiTaskGameIconTips,
} from '@op/components/BubbleCommon';
import PermissionCapsule from '@op/components/ReportPermission/PermissionCapsule';
import '@op/components/ReportPermission/index.scss';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { NO_DATE } from '@op/constants';
import { GPTStatus } from '@op/constants/GPT';
import moment from 'moment';
import React from 'react';
import { Bubble, Button, Dropdown, List } from 'tea-component';
import { getLocale } from 'umi';

export const getStatusInfo = (records: {
  status: string;
  summary_status: string;
  category: string;
  cycle_end_date?: string;
}) => {
  let status = records?.status || records.summary_status;
  // 例行报告空状态 = 等待
  if (!status && !records?.cycle_end_date) return null;
  status = status || 'init';
  const { color, text } = GPTStatus?.[status] || {};
  const realText =
    text === 'In queue' && records?.category === 'url'
      ? 'Processing'
      : text;
  return { color, realText };
};

export const summaryListColumnFunc = (props: any) => {
  const {
    formatMessage,
    clickDownload,
    clickPreview,
    clickDelete,
    clickStop,
    clickResume,
    toggleModal,
    noNewTagsReport,
    newTagLoading,
    gameInfoMap,
    handleChangeGame,
    tab,
    onOpenPermissionPanel,
  } = props;
  const isEN = getLocale() === LANGUAGE_EN;
  return {
    analysis_name: {
      key: 'name',
      header: formatMessage({
        id: gameInfoMap ? 'Game Analysis Name' : 'Analysis Name',
      }),
      align: 'left',
      width: 340,
      render: (records: any) => {
        const nameEN = records?.name;
        const nameCN = records?.name_cn || records?.name;
        const name = isEN ? nameEN : nameCN;
        const gameInfo = gameInfoMap?.[records?.game_id || ''];
        return (
          <div className="dbo-flex-h100">
            {gameInfo && (
              <BubbleCommon
                tipsMap={aiTaskGameIconTips(gameInfo.entity_name)}
                showIcon={false}
                placement="top"
              >
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleChangeGame(gameInfo, true)}
                >
                  <RenderGameIcon
                    className="dbo-videobox-cover"
                    gameInfo={gameInfo}
                    imgStyle={{
                      width: 20,
                      height: 20,
                      marginRight: 5,
                      borderRadius: 4,
                      flex: 'none',
                    }}
                  ></RenderGameIcon>
                </div>
              </BubbleCommon>
            )}
            <Bubble content={name} placement="top" dark>
              <Button
                className="dbo-single-ellipsis"
                type="link"
                onClick={() => clickPreview(records)}
              >
                {name}
              </Button>
            </Bubble>
            {noNewTagsReport !== undefined &&
              !newTagLoading &&
              !noNewTagsReport?.[records.id] && (
                <div className="dbo-new-tag" style={{ marginLeft: '0' }}>
                  New
                </div>
              )}
          </div>
        );
      },
    },
    create_time: {
      key: 'create_time',
      header: formatMessage({ id: 'Create Time' }),
      width: 140,
      render: (records: any) =>
        moment(records.create_time).format('YYYY-MM-DD HH:mm:ss'),
    },
    creator: {
      key: 'user_name',
      header: formatMessage({ id: 'Creator' }),
      width: 120,
    },
    status: {
      key: 'status',
      header: formatMessage({ id: 'Status' }),
      width: 120,
      render: (records: {
        status: string;
        summary_status: string;
        category: string;
        cycle_end_date?: string;
      }) => {
        const status = getStatusInfo(records);

        return (
          <span className={`dbo-saved-analysis-list-table-status`}>
            <span
              className="status-dot"
              style={{ backgroundColor: status?.color }}
            ></span>
            {formatMessage({ id: status?.realText || NO_DATE.EMPTY })}
          </span>
        );
      },
    },
    permission: {
      key: 'permission',
      header: formatMessage({ id: 'Access' }),
      width: 140,
      render: (records: any) => {
        const canEditPermission = !!records?.can_edit_permission;
        return (
          <PermissionCapsule
            record={records}
            editable={canEditPermission}
            onClick={(records, event: any) => {
              event.stopPropagation();
              onOpenPermissionPanel?.(records, event);
            }} />
        );
      },
    },
    action: {
      key: 'action',
      header: formatMessage({ id: 'Action' }),
      width: 180,
      render: (records: any) => {
        const status = getStatusInfo(records);
        const disabled = status?.realText !== 'Done';
        const canEditPermission = !!records?.can_edit_permission;

        return (
          <div className="dbo-saved-analysis-list-table-action">
            <BubbleCommon
              tipsMap={disabled ? aiTaskDownloadDisabledTips : null}
              showIcon={false}
            >
              <Button
                type="link"
                disabled={disabled}
                onClick={() => clickDownload(records)}
              >
                {formatMessage({ id: 'Download' })}
              </Button>
            </BubbleCommon>
            {canEditPermission && (
              <Button
                type="link"
                onClick={(event: any) => {
                  event.stopPropagation();
                  onOpenPermissionPanel?.(records, event);
                }}
              >
                {formatMessage({ id: 'Access' })}
              </Button>
            )}
            <Button
              type="link"
              disabled={records.is_creator !== 1}
              onClick={() => clickDelete(records)}
            >
              {formatMessage({ id: 'Delete' })}
            </Button>
          </div>
        );
      },
    },
    last_report_generated_time: {
      key: 'last_report_generated_time',
      header: formatMessage({ id: 'Last Generate Time' }),
      width: 140,
      render: (records: any) =>
        records.last_report_generated_time
          ? moment(records.last_report_generated_time).format(
            'YYYY-MM-DD HH:mm:ss',
          )
          : '-',
    },
    multi_action: {
      key: 'multi_action',
      header: formatMessage({ id: 'Action' }),
      width: 180,
      render: (records: any) =>
        !records?.is_creator ? (
          <Button
            type="link"
            onClick={() => toggleModal('detail', { records })}
          >
            {formatMessage({ id: 'Detail' })}
          </Button>
        ) : (
          <div className="dbo-saved-analysis-list-table-action">
            <Button
              type="link"
              onClick={() => toggleModal('detail', { records })}
            >
              {formatMessage({ id: 'Detail' })}
            </Button>
            <Button
              type="link"
              onClick={(event) => {
                event?.stopPropagation();
                onOpenPermissionPanel?.(records, event);
              }}
              disabled={records.can_edit_permission === false}
            >
              {formatMessage({ id: 'Access' })}
            </Button>
            <Dropdown
              className="dbo-subscriptions-more-dropdown"
              overlayClassName="dbo-subscriptions-more-dropdown-box"
              clickClose={false}
              button={formatMessage({ id: 'More' })}
              disabled={records.can_edit_permission === false}
            >
              <List type="option">
                <List.Item
                  onClick={() => toggleModal('edit', { records }, tab)}
                >
                  {formatMessage({ id: 'Edit' })}
                </List.Item>
                <List.Item onClick={() => clickDelete(records)}>
                  {formatMessage({ id: 'Delete' })}
                </List.Item>
                {records?.status === 'stopped'
                  ? clickResume && (
                    <List.Item onClick={() => clickResume(records)}>
                      {formatMessage({ id: 'Resume' })}
                    </List.Item>
                  )
                  : clickStop && (
                    <List.Item onClick={() => clickStop(records)}>
                      {formatMessage({ id: 'Stop-1' })}
                    </List.Item>
                  )}
              </List>
            </Dropdown>
          </div>
        ),
    },
  };
};
